import React, {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import "./MedicalEmergencyDetails.css";
import { Accordion, AccordionPanel, Box, Button, Menu, ResponsiveContext, Text, TextArea } from "grommet";
import MedicalEmergencyCard from "../common/MedicalEmergencyCard/MedicalEmergencyCard";
import { PassengerType } from "../../../../../../services/passenger/typings/PassengerType";
import PassengerService from "../../../../../../services/passenger/passenger.service";
import StandardColors from "../../../../../../util/StandardColors";
import CustomCard from "../../../common/card/CustomCard";
import EventTimeline from "../common/EventTimeline/EventTimeline";
import { EventApiResponseType } from "../../../../../../services/events/typings/EventApiResponseType";
import { EventTypeToTextMapper } from "../common/EventTimeline/EventTypeMapper";
import { useNavigate, useParams } from "react-router-dom";
import EventService from "../../../../../../services/events/event.service";
import { StyleSheet } from "../../../../../../typings/StyleSheet";
import ChatCard, { ChatType } from "../../../common/chat/ChatCard";
import VideocallResponseType from "../../../../../../services/videocall/typings/VideocallResponseType";
import MedicalEmergencyService from "../../../../../../services/medical-emergency/medical-emergency.service";
import { useUser } from "../../../../context/User/UserContext";
import { IoVideocamOutline } from "react-icons/io5";
import { MedicalEmergencyStatus } from "../../../../../../services/medical-emergency/typings/IMedicalEmergencyApiResponse";

import ConfirmationDialog from "../../../common/confirmation-dialog/ConfirmationDialog";
import LoginPrompt from "../../../common/login-prompt/LoginPrompt";
import { FlightService } from "../../../../../../services/flights/flight.service";
import ReportButton from "../common/Report/ReportButton/ReportButton";
import ReportManager from "../../../../../../util/report/ReportManager";
import { ReportNameEnum } from "../../../../../../util/report/ReportNameEnum";

import ImageViewer from "react-simple-image-viewer";
import IFlightResponse from "../../../../../../services/flights/typings/IFlightResponse";

import { Responsive, WidthProvider } from "react-grid-layout";
import { NotificationHelper } from "../../../../../../util/notification/NotificationHelper";
import { MedicalEmergencyHelper } from "../../../../../../util/medical-emergency/MedicalEmergencyHelper";

// import { useIndicator } from "../../../../context/IndicatorContext/IndicatorContext";
import { useReport } from "../../../../context/IndicatorContext/IndicatorContext";
import { useStore } from "../../../../../../Hooks/useStore";
import {observer} from 'mobx-react';
import { Mixpanel } from "../../../../../../util/Helper";

import edit from '../../../../../../assets/notesEditIcon.svg';
import medicalKit from '../../../../../../assets/medical_kit.svg';
import closeSmall from '../../../../../../assets/close_small.svg';
import nodata from '../../../../../../assets/no-data.svg';
import troubleshot from '../../../../../../assets/knowmore.svg';
import docScanner from '../../../../../../assets/document_scanner.svg';
import backArrow from '../../../../../../assets/arrow_back.svg';
import reportFlowSheet from '../../../../../../assets/flowsheet.svg';
import seeAll from '../../../../../../assets/see_all.svg';
import { Close } from "grommet-icons";
import ReportList from "./ReportList";
import { subscribeToTopic ,unsubscribeToTopic,sendDataToTopic} from "../../../../../../App";
import { Autoupdateenum } from "../../../../../../enums";
import VideocallService from "../../../../../../services/videocall/videocall.service";
import Sidebar from "./Sidebar";
import { Auth } from "aws-amplify";
import ResolvedRestrictModal from "./ResolveRestrictModal/ResolvedRestrictModal";
import { VideoCallNotificationHelper } from "../../../../../../util/notification/VideoCallNotificationHelper";
import Se from "../../../../../../assets/troubleshoot.svg"
import reportDown from "../../../../../../assets/report_arrow_drop.png"
import Utility from "../../../../../../util/api/Utility";
import Assistant from "./Assistant/Assistant";
import axios from "axios";
import usersService from "../../IAM/Users/users.service";
import { APIs } from "../../../../../../util/api/APIs";


const ResponsiveGridLayout = WidthProvider(Responsive);

const MedicalEmergencyDetails = observer(() => {

  const { rootStore } = useStore();
  const captainChat = useRef<HTMLDivElement>(null);
  const crewChat = useRef<HTMLDivElement>(null);

  // const { setShowIndicators, indicators } = useIndicator();
  const { medicalEmergencyId } = useParams();
  const { user } = useUser();
  const {report, handleNewReportNotification} = useReport();
  const size = useContext(ResponsiveContext);
  const [showMoreReport, setShowMoreReport] = useState(false);
  const [expand, setExpand] = useState(false);
  const [onlineStatus, setOnlineStatus] = useState(false);
  const [diversion, setDiversion] = useState('');
  const [flightLanded, setFlightLanded] = useState(false);
  const [pageRefresh, setPageRefresh] = useState(0);
  const [passenger, setPassenger] = useState({} as PassengerType);
  const [notes, setNotes] = useState("");
  const [flight, setFlight] = useState({} as IFlightResponse);
  const [events, setEvents] = useState<EventApiResponseType[]>([]);
  const [videocallRecord, setVideocallRecord] =
    useState<VideocallResponseType | null>(null);
  const [dialogState, setDialogState] = useState({
    showConfirmation: false,
    showLoginPrompt: false,
  });
  const [reportImageState, setReportImageState] = useState({
    showImage: false,
    imageUrl: "",
  });
  const [responsiveState, setResponsiveState] = useState({
    showEmergencyDetails: true,
  });
  const [reportIndicator, setReportIndicator] = useState({
    glucoMeter: false,
    bloodPressure: false,
    oxiMeter: false,
    aed: false,
  });
  const [flightRoomId, setFlightRoomId] = useState("");
  const [medicalKitItems, setMedicalKitItems] = useState<Array<{ name: string }>>([]);

  const [searchTerm, setSearchTerm] = useState("");

  const filteredItems = medicalKitItems.filter(item =>
    item.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // derived state management functions
  const setShowEmergencyDetails = (state: boolean) =>
    rootStore.emsStore.handleResponsiveState(state);
    // setResponsiveState((prev) => {
    //   return { ...prev, showEmergencyDetails: state };
    // });

  const navigation = useNavigate();

  // get chat box height , width
  useEffect(() => {
    const observeBoxHeight = () => {
      if (!crewChat.current) return;
      const observer = new ResizeObserver(entries => {
        for (let entry of entries) {
          const newHeight = entry.contentRect.height;
          const newWidth = entry.contentRect.width;

          const newDimensionObj = {
            height: newHeight,
            width: newWidth
          }
          rootStore.emsStore.setCrewChat(newDimensionObj);
        }
      });
      
      observer.observe(crewChat.current);

      return () => {
        observer.disconnect();
      };
    };
    {
      rootStore.emsStore.getExpand == false
              &&
      observeBoxHeight();
      
    }
  }, []);

  useEffect(() => {
    if (rootStore.emsStore.getFlightRecord) {
      FlightService.getFlight(rootStore.emsStore.getFlightRecord.id).then((flightResponse) => {
        // setFlightRoomId(flightResponse.roomId);
        rootStore.emsStore.handleFlightRoomId(flightResponse.roomId);
        // setFlightLanded(flightResponse.planeLandedStatus);
        rootStore.emsStore.handleFlightLanded(flightResponse.planeLandedStatus);
        // setOnlineStatus(flightResponse.internetStatus);
        console.log("flight room id: ", flightResponse.roomId);
      });
    }
  }, [rootStore.emsStore.getFlightRecord]);

  useEffect(() => {
    if(user && user["custom:type"] == "ems") {
      (async () =>{
        console.log("siya- rootStore.emsStore.getSelectedEmergency", rootStore.emsStore.getSelectedEmergency);
      if (rootStore.emsStore.getSelectedEmergency !== null) {
        if (rootStore.emsStore.getSelectedEmergency?.assignedEms === user?.username && rootStore.emsStore.getSelectedEmergency?.status == "NOTIFIED") {

        

            await MedicalEmergencyService.setMedicalEmergencyStatus(
              rootStore.emsStore.getSelectedEmergency.id,
              MedicalEmergencyStatus.MONITORING
            );
              //status update
          sendDataToTopic(rootStore.emsStore.getSelectedEmergency?.id,rootStore.emsStore.getSelectedEmergency.flightId,Autoupdateenum.Emergency);
            rootStore.emsStore.handlePageRefreshCount(rootStore.emsStore.getpageRefreshCount + 1);
          }
        }
      })();
    }
  },[rootStore.emsStore.getSelectedEmergency]);

  useEffect(() => {
    if (rootStore.emsStore.getSelectedEmergency) {
      const flightId = rootStore.emsStore.getSelectedEmergency?.flightId;
      console.log("testssss"+flightId); // 
      console.log(JSON.stringify(rootStore.emsStore.getFlightsubscribe));
      if (!rootStore.emsStore.getFlightsubscribe[flightId]) {
            console.log("test"+flightId); // Log the flightId
    
            // Mark this flightId as logged
          rootStore.emsStore.handleFlightsubscribe(flightId);
             subscribeToTopic(flightId,rootStore);
       }
    }
  },[rootStore.emsStore.getSelectedEmergency]);

  const loadEmergenciesAndFlight = useCallback(async () => {
    if (medicalEmergencyId) {
      const medicalEmergencyFromAPI =
        await MedicalEmergencyService.getMedicalEmergency(medicalEmergencyId);
        rootStore.emsStore.handleFlightID(medicalEmergencyFromAPI.flightId);
        rootStore.emsStore.handleSelectedEmergency(medicalEmergencyFromAPI);
        rootStore.emsStore.handleDiversionStatus(medicalEmergencyFromAPI.diversionDecisionStatus);
      const flightFromAPi = await FlightService.getFlight(
        medicalEmergencyFromAPI.flightId
      );
      rootStore.emsStore.flightRecord = flightFromAPi;
      rootStore.emsStore.handleOnlineStatus(flightFromAPi.internetStatus);
    }
  }, [medicalEmergencyId, rootStore.emsStore.getpageRefreshCount]);

  useEffect(() => {
    
    loadEmergenciesAndFlight();
  }, [medicalEmergencyId, rootStore.emsStore.handleSelectedEmergency, rootStore.emsStore.getpageRefreshCount]);
  useEffect(() => {
    loadEmergenciesAndFlight();
    if ( rootStore.emsStore.getNotificationTitleandMsg.notificationTitle != null && rootStore.emsStore.getNotificationTitleandMsg.notificationMessage != null ) {
      let getFlightId = rootStore.emsStore.getNotificationTitleandMsg.notificationTitle.split(":");
      var getfinalid = getFlightId[1].trim();
      let isSame = getfinalid === rootStore.emsStore.getFlightId;
      if (isSame) {
          if(rootStore.emsStore.getNotificationTitleandMsg.notificationMessage == 'online') {
            rootStore.emsStore.handleOnlineStatus(true);
          } else {
            rootStore.emsStore.handleOnlineStatus(false);
          }
      }
    }
  }, [rootStore.emsStore.getNotificationTitleandMsg.notificationTitle, rootStore.emsStore.getNotificationTitleandMsg.notificationMessage, loadEmergenciesAndFlight, rootStore.emsStore.getFlightId]);
  
  useEffect(() => {
    (async () => {
      if (rootStore.emsStore.getSelectedEmergency != null) {
        // rootStore.emsStore.handleNotes("");
        const passenger = await PassengerService.getPassenger(
          rootStore.emsStore.getSelectedEmergency.passengerId
        );
        if (passenger != null) {
          // setPassenger(passenger);
          rootStore.emsStore.passenger = passenger;
        }
      }

      // load events of medical emergency
      let events_ = [] as EventApiResponseType[];
      if (rootStore.emsStore.getSelectedEmergency != null) {
        //alert(rootStore.emsStore.getSelectedEmergency?.notes );
        rootStore.emsStore.handleAllNotes("plain",rootStore.emsStore.getSelectedEmergency?.plain);
        rootStore.emsStore.handleAllNotes("assesment",rootStore.emsStore.getSelectedEmergency?.assesment);
        rootStore.emsStore.handleAllNotes("objective",rootStore.emsStore.getSelectedEmergency?.objective);
        rootStore.emsStore.handleAllNotes("subjective",rootStore.emsStore.getSelectedEmergency?.subjective);
        rootStore.emsStore.handleNotes(rootStore.emsStore.getSelectedEmergency?.notes as string);
        events_ = await EventService.getEventsbyMedicalEmergencyId(
          rootStore.emsStore.getSelectedEmergency.id
        );
      }
      rootStore.emsStore.handleEvents(events_);
      // setEvents(events_);
    })();
    // eslint-disable-next-line no-undef
    const controller = new AbortController();

    // If medicalEmergency is set
    if (rootStore.emsStore.getSelectedEmergency) {
      const videocallRecordPromise =
        MedicalEmergencyService.getVideocallRecordForMedicalEmergency(
          rootStore.emsStore.getSelectedEmergency.id,
          controller.signal
        );
      videocallRecordPromise.then((videocallRecordFromResponse) => {
        // setVideocallRecord(videocallRecordFromResponse);
        rootStore.emsStore.videocallRecord = videocallRecordFromResponse;
      });
    }

    return () => {
      controller.abort();
    };
  }, [rootStore.emsStore.getSelectedEmergency]);

  useEffect(() => {
    if (size === "large" || size === "medium") {
      setShowEmergencyDetails(true);
    }
  }, [size]);

  const onVideocallBtnClicked = async () => {
    Mixpanel.track("web_video_call_click",{name:user?.username});
    let videoCallInfo;
    if (medicalEmergencyId) {
      const videocallRecord =
      await MedicalEmergencyService.getVideocallRecordForMedicalEmergency(
        Number.parseInt(medicalEmergencyId)
      );
      let roomId = videocallRecord.roomId.split(",")[0];
      videoCallInfo = {
        "navigate":"videoCall",
        "flightId": rootStore.emsStore.getSelectedEmergency?.flightId,
        "roomId": roomId,
        "emergencyId": medicalEmergencyId
      }  
    }

    notifyUsers("Call answered", user?.username ?? "EMS",videoCallInfo);
    try {
      (async () => {
        const session = await Auth.currentSession();
        const accessToken = session.getAccessToken().getJwtToken();
        VideocallService.initiateVideoCallData(accessToken);
      })();
    } catch (e) {
      console.log("Initiate video call access post", e);
    }
    //open window
    //const strWindowFeatures =
    // "location=yes,height=570,width=720,scrollbars=yes,status=yes";
    const strWindowFeatures =
      "location=yes,height=570,width=720,scrollbars=yes,status=yes";
    const url = "/call/" + medicalEmergencyId;
    const win = window.open(url, "videocall", strWindowFeatures);
    win?.focus();
  };

  const onAudiocallBtnClicked = async (emergencyId: number, fId: string, videoCall: string = "off",callType: string) => {
     Mixpanel.track("web_call_click",{name:user?.username});
    let audioCallInfo;
    if (medicalEmergencyId && rootStore.emsStore.getSelectedEmergency) {
      sendDataToTopic(medicalEmergencyId+"#"+user?.username+"#"+"ems",rootStore.emsStore.getSelectedEmergency.flightId,Autoupdateenum.VoiceCall);
      const videocallRecord =
      await MedicalEmergencyService.getVideocallRecordForMedicalEmergency(
        Number.parseInt(medicalEmergencyId)
      );
      if (videocallRecord.roomId != null) {
        let roomId = videocallRecord.roomId.split(",")[0];
        audioCallInfo = {
          "navigate":"videoCall",
          "flightId": rootStore.emsStore.getSelectedEmergency?.flightId,
          "roomId": roomId,
          "emergencyId": medicalEmergencyId
        }  
      }
    }

    notifyUsers("Call initiated", user?.username ?? "EMS",audioCallInfo);
    if (videoCall == "on") {
      try {
        (async () => {
          const session = await Auth.currentSession();
          const accessToken = session.getAccessToken().getJwtToken();
          VideocallService.initiateVideoCallData(accessToken);
        })();
      } catch (e) {
        console.log("Initiate video call access post", e);
      }
    }
    const strWindowFeatures =
      "location=yes,height=570,width=720,scrollbars=yes,status=yes";
    const url = "/call/" + medicalEmergencyId + "/" + videoCall;
    // alert(JSON.stringify(url))
   
    const win = window.open(url, "audiocall", strWindowFeatures);
    
    rootStore.callingStore.handleChildWindowRef(win);    
    

    win?.focus();
    let token;
    try {
      let response = await MedicalEmergencyService.getFcmToken();
      token = response.split("Access Token: ")[1];
      console.log("FCM token response", token);
    } catch (error) {
      console.log("Error fetching FCM token", error);
    }
    if ( token ) {
      let crewRecord;
      try {
        const medicalEmergencyHelper = new MedicalEmergencyHelper();
        let cognitoUserIdCrew = await medicalEmergencyHelper.findCrewName(medicalEmergencyId);
        console.log("cognitoUserIdCrew",cognitoUserIdCrew);
        if (cognitoUserIdCrew) {
          await usersService.listUsersByUsername(cognitoUserIdCrew)
          .then((res) => {
            crewRecord = res;
          })
          .catch((error) => {
            console.log("Error fetching crew record", error);
          })
        }
      } catch (error) {
        console.log("Error fetching crew name", error);
      }
        console.log("crew user records", crewRecord);
      if (crewRecord && crewRecord[0]["custom:fcmtoken"]) {
        console.log('crewRecord[0]["custom:fcmtoken"]', crewRecord[0]["custom:fcmtoken"])
      let headersList = {
        "Content-Type": "application/json",

        Authorization:
          `Bearer ${token}`,
      };

      let bodyContent = JSON.stringify({
        validate_only: false,

        message: {
          token: crewRecord[0]["custom:fcmtoken"],

          data: {
            type: callType,
            flight_id: fId,
            emergency_id: emergencyId.toString(),
            content_available: "true",
          },
        },
      });
      try {

        
        let mesagesendurl;
        if (APIs.BASE_URL.indexOf("sbx") >= 0) {
          mesagesendurl = "https://fcm.googleapis.com/v1/projects/skalisbx/messages:send";
        } else if (APIs.BASE_URL.indexOf("poc") >= 0) {
          mesagesendurl = "https://fcm.googleapis.com/v1/projects/skalisbx/messages:send";
        } else {
          mesagesendurl = "https://fcm.googleapis.com/v1/projects/skali-inc/messages:send";
        }

        let response = await fetch(
          mesagesendurl,
          {
            method: "POST",

            body: bodyContent,

            headers: headersList,
          }
        );

        let data = await response.text();

        console.log(data);
      } catch (error) {
        console.error("Call Api error", error);
      }
    }
    }
  };

  const onMarkResolvedButtonClick = async (username?: string) => {
    if (rootStore.emsStore.getSelectedEmergency?.assignedEms && username && username !== rootStore.emsStore.getSelectedEmergency?.assignedEms) {
      rootStore.emsStore.handleResolvedPopUp(true);
      return;
    }
    Mixpanel.track("web_mark_resolved_click",{name:user?.username});
    if ( rootStore.emsStore.getSelectedEmergency ) {

      rootStore.emsStore.handleDialogState({showConfirmation: true,showLoginPrompt: rootStore.emsStore.getDialogState.showLoginPrompt});

      // await FlightService.getFlight(rootStore.emsStore.getSelectedEmergency?.flightId).then((flightResponse) => {      
      //   if (flightResponse.planeLandedStatus == true) {
      //     rootStore.emsStore.handleDialogState({showConfirmation: true,showLoginPrompt: rootStore.emsStore.getDialogState.showLoginPrompt});
      //     // setDialogState((prev) => {
      //     //   return { ...prev, showConfirmation: true };
      //     // });

      //   } else {
      //     alert('You are unable to mark the medical emergency as resolved as the plane has not yet landed.');
      //   }
      // });
    }
  };

  const markResolved = async () => {
    if (rootStore.emsStore.getSelectedEmergency) {
      MedicalEmergencyService.setMedicalEmergencyStatus(
        rootStore.emsStore.getSelectedEmergency?.id,
        MedicalEmergencyStatus.RESOLVED
      )
        .then(() => {
          const selectedEmergencyId = rootStore.emsStore.getSelectedEmergency?.id?.toString() || '';
          MedicalEmergencyService.getMedicalEmergency(selectedEmergencyId).then((data) => rootStore.emsStore.handleSelectedEmergency(data));
          sendDataToTopic(rootStore.emsStore.getSelectedEmergency?.id,rootStore.emsStore.getSelectedEmergency?.flightId,Autoupdateenum.Emergency);
          rootStore.emsStore.handleDialogState({showConfirmation: false,showLoginPrompt: rootStore.emsStore.getDialogState.showLoginPrompt});
          // setDialogState((prev) => {
          //   return { ...prev, showConfirmation: false };
          // });
        })
        .catch((e) => {
          rootStore.emsStore.handleDialogState({showConfirmation: false,showLoginPrompt: rootStore.emsStore.getDialogState.showLoginPrompt});
          // setDialogState((prev) => {
          //   return { ...prev, showConfirmation: false };
          // });
        });
    }
  };

  const onRecommendDiversionClicked = () => {
    Mixpanel.track("web_recommend_diversion_click",{name:user?.username});
    rootStore.emsStore.handleDialogState({showConfirmation: rootStore.emsStore.getDialogState.showConfirmation,showLoginPrompt: true});

    sendDataToTopic(rootStore.emsStore.getSelectedEmergency?.id,rootStore.emsStore.getSelectedEmergency?.flightId,Autoupdateenum.Emergency);
    sendDataToTopic(rootStore.emsStore.getSelectedEmergency?.id,rootStore.emsStore.getSelectedEmergency?.flightId,Autoupdateenum.FlightStatus);
    // setDialogState((prev) => {
    //   return {
    //     ...prev,
    //     showLoginPrompt: true,
    //   };
    // });
  };

  const onContinueWithoutContactClicked = () => {
    Mixpanel.track("web_continue_and_monitor_click",{name:user?.username});
    const Url = window.location.href;
    const parts = Url.split("/");
    const emergencyId = Number(parts.at(-1));
    // MONITORING
    MedicalEmergencyService.setMedicalEmergencyStatus(
      emergencyId,
      MedicalEmergencyStatus.CONTINUE_AND_MONITOR
    )
      .then(() => {
        rootStore.emsStore.handlePageRefreshCount(rootStore.emsStore.getpageRefreshCount + 1);
        // setPageRefresh(pageRefresh + 1);
        // setDialogState((prev) => {
        //   return { ...prev, showConfirmation: false };
        // });
        
      })
      .catch((e) => {
        rootStore.emsStore.handleDialogState({showConfirmation: false,showLoginPrompt: rootStore.emsStore.getDialogState.showLoginPrompt});
        // setDialogState((prev) => {
        //   return { ...prev, showConfirmation: false };
        // });
      });
  };

  const cancelLoginPrompt = () => {
    rootStore.emsStore.handleDialogState({showConfirmation: rootStore.emsStore.getDialogState.showConfirmation,showLoginPrompt: false});
  };
  
  const recommendDiversion = async () => {
    cancelLoginPrompt();
    rootStore.loadingStore.setShowLoader(true);
    try {
      if (rootStore.emsStore.getSelectedEmergency) {
        await MedicalEmergencyService.recommendDiversion(
          rootStore.emsStore.getSelectedEmergency?.id
        );
        rootStore.emsStore.handlePageRefreshCount(rootStore.emsStore.getpageRefreshCount + 1);
        sendDataToTopic(rootStore.emsStore.getSelectedEmergency?.id,rootStore.emsStore.getSelectedEmergency?.flightId,Autoupdateenum.Emergency);
        sendDataToTopic(rootStore.emsStore.getSelectedEmergency?.id,rootStore.emsStore.getSelectedEmergency?.flightId,Autoupdateenum.FlightStatus);
      }
    } catch (e) {
      alert("Failed to recommend diversion, please check your network.");
    } finally {
      rootStore.loadingStore.setShowLoader(false);
    }
  };

  const onRecommendDispositionButtonClick = async () => {
    rootStore.loadingStore.setShowLoader(true);
    try {
      if (rootStore.emsStore.getSelectedEmergency) {
        await FlightService.updateFlightDisposition(
          rootStore.emsStore.getSelectedEmergency?.flightId
        );
        rootStore.emsStore.handlePageRefreshCount(rootStore.emsStore.getpageRefreshCount + 1);
        // setPageRefresh(pageRefresh + 1);
      }
    } catch (e) {
      alert("Failed to recommend disposition, please check your network.");
    } finally {
      rootStore.loadingStore.setShowLoader(false);
    }
  };

  const onNotificationDisabled = async (notificationStatus: string) => {
    Mixpanel.track("web_reminder_notification_" + notificationStatus,{name:user?.username});
    if(rootStore.emsStore.getSelectedEmergency) {
      await MedicalEmergencyService.updateNotificationShow(rootStore.emsStore.getSelectedEmergency.id, notificationStatus);
      rootStore.emsStore.handlePageRefreshCount(rootStore.emsStore.getpageRefreshCount + 1);
      // setPageRefresh(pageRefresh + 1);
    }
  }
  interface MenuItem {
    label: string;
    onClick: () => void;
    disabled?: boolean; // Add the disabled property
  }
  const menuItems: MenuItem[] = [
    {
      label: "Recommend Diversion",
      onClick: onRecommendDiversionClicked,
    },
    {
      label: "Continue and Monitor",
      onClick: onContinueWithoutContactClicked,
    },
  ]

  // if(user && user["custom:type"] == "ems") {
  //   menuItems.push({
  //     label: "Recommend Disposition",
  //     onClick: onRecommendDispositionButtonClick,
  //   })
  // }
  if(rootStore.emsStore.getSelectedEmergency) {
    if(user && user["custom:type"] == "ems") {
      let notificationHandler = {} as MenuItem;
      if (rootStore.emsStore.getSelectedEmergency.notificationShow == "on" || rootStore.emsStore.getSelectedEmergency.notificationShow == null && rootStore.emsStore.getSelectedEmergency.status != "RESOLVED") {
        notificationHandler.label = "Disable Notification";
        notificationHandler.onClick = () => onNotificationDisabled('off');
      } else {
        notificationHandler.label = "Enable Notification";
        notificationHandler.onClick = () => onNotificationDisabled('on');
      }
      menuItems.push(notificationHandler);
    }
  }

  
  const actionButtons = (val: boolean) => {
    return (
      <Menu
        fill
        alignSelf="center"
        justify="center"
        justifyContent="center"
        label="Actions"
        style={{ fontSize: 12 }}
        items={menuItems}
        disabled={rootStore.emsStore.getSelectedEmergency?.status == "RESOLVED" ? true : false}
      />
    );
  };

  const closeImage = () => {
    rootStore.emsStore.handleReportImageState({imageUrl: rootStore.emsStore.getReportImageState.imageUrl, showImage: false});
  };

  const closeChatImage = () => {
    rootStore.emsStore.handleChatImageState({imageUrl: rootStore.emsStore.getChatImageState.imageUrl, showImage: false});
  }

  const notifyUsers = useCallback(
    async (sentBy: string, messageContent: string, videoParams: any) => {
      if (!user || !rootStore.emsStore.getSelectedEmergency) return;
      const notificationHelper = new VideoCallNotificationHelper();
      const medicalEmergencyHelper = new MedicalEmergencyHelper();
      let users = [];
      let cognitoUserId = null;
      if (user["custom:type"] === "crew") {
        cognitoUserId = await medicalEmergencyHelper.findEms(
          rootStore.emsStore.getSelectedEmergency.id
        );
      } else {
        cognitoUserId = await medicalEmergencyHelper.findCaptain(
          rootStore.emsStore.getSelectedEmergency.flightId
        );

        if (cognitoUserId) {
          users.push(cognitoUserId);
        }

        cognitoUserId = await medicalEmergencyHelper.findCrew(
          rootStore.emsStore.getSelectedEmergency.id
        );
      }
      if (cognitoUserId) {
        users.push(cognitoUserId);
      }
      if (users.length != 0) {
        notificationHelper.sendVideoCallNotification(sentBy, messageContent, users, videoParams);
      }
    },
    [rootStore.emsStore.getSelectedEmergency, user]
  );

  const onReportButtonClick = async (reportName: ReportNameEnum, reportTitle: string) => {
    Mixpanel.track("web_report_click_" + reportName,{name:user?.username});
    rootStore.emsStore.setReportTitle(reportTitle);
    if (rootStore.emsStore.getSeeAll) {
      rootStore.emsStore.setReportList();
    } else {
      rootStore.emsStore.setReportList();
      rootStore.emsStore.setSeeAll();
    }
    rootStore.loadingStore.setShowLoader(true);
    try {
      if (rootStore.emsStore.getAllReportList) {
        let filterReportArray = rootStore.emsStore.getAllReportList.filter((report: any) => report.imageType == reportName)
        if (filterReportArray) {
          rootStore.emsStore.setFilterReportList(filterReportArray);
        } else {
          alert("Report not uploaded yet.");
        }
      }
    } catch (e) {}
    rootStore.loadingStore.setShowLoader(false);
  };

  const ReportLength = async () => {
    try {
      if (medicalEmergencyId) {
        const url = await FlightService.getReports(parseInt(medicalEmergencyId));
        if (url) {
          console.log("report list on page load", url);
          rootStore.emsStore.setAllReportList(url);
          url.map((report: any) => {
            if (report.imageType == 'gm') {
              rootStore.emsStore.handleReportInticator("glucoMeter", true);
            } else if (report.imageType == 'po') {
                rootStore.emsStore.handleReportInticator("oxiMeter", true);
            } else if (report.imageType == 'bpm') {
                rootStore.emsStore.handleReportInticator("bloodPressure", true);
            } else if (report.imageType == 'thermometer') {
                rootStore.emsStore.handleReportInticator("aed", true);
            } else {
              console.log(url);
            }
          });
        } 
      }
    } catch (e) {}
  };

  const chatCardLargeLayouts = useMemo(() => {
    return rootStore.emsStore.getFlightRoomId !== ""
      ? [
          { i: "chat-card", x: 10, y: 0, w: 9, h: 4, static: true },
          {
            i: "chat-card-flight-captain",
            x: 10,
            y: 4,
            w: 9,
            h: 4,
            static: true,
          },
        ]
      :
      [
        { i: "chat-card", x: 10, y: 0, w: 9, h: 4, static: true },
        {
          i: "chat-card-flight-captain",
          x: 10,
          y: 4,
          w: 9,
          h: 4,
          static: true,
        },
      ];
      // : [{ i: "chat-card", x: 10, y: 0, w: 9, h: 8, static: true }];
  }, [rootStore.emsStore.getFlightRoomId]);

  const layout_large = useMemo(
    () => [
      { i: "medical-emergency-card", x: 0, y: 0, w: 10, h: 5, static: true },
      ...chatCardLargeLayouts,
      {
        i: "report-buttons",
        x: 19,
        y: user && user["custom:type"] === "admin" ? 0 : 3,
        w: 5,
        h: user && user["custom:type"] === "admin" ? 9 : 6,
        static: true,
      },
      { i: "actions", x: 19, y: 0, w: 5, h: 1, static: true },
      { i: "video-call-button", x: 10, y: 8, w: 9, h: 1, static: true },
      { i: "notes", x: 0, y: 6, w: 10, h: 4, static: true },
    ],
    [user, chatCardLargeLayouts]
  );

  const chatCardMediumLayouts = useMemo(() => {
    return rootStore.emsStore.getFlightRoomId !== ""
      ? [
          { i: "chat-card", x: 0, y: 4, w: 9.5, h: 4, static: false },
          {
            i: "chat-card-flight-captain",
            x: 9.5,
            y: 4,
            w: 9.5,
            h: 4,
            static: false,
          },
        ]
      : [{ i: "chat-card", x: 0, y: 0, w: 19, h: 4, static: false }];
  }, [rootStore.emsStore.getFlightRoomId]);

  const layout_medium = useMemo(
    () => [
      {
        i: "medical-emergency-card",
        x: 0,
        y: size === "medium" || size === "large" ? 0 : 1,
        w: 19,
        h: rootStore.emsStore.getResponsiveState.showEmergencyDetails ? 7 : 0,
        static: false,
      },
      ...chatCardMediumLayouts,
      { i: "notes", x: 0, y: 9, w: 9.5, h: 4, static: false }, // h: 1
      { i: "video-call-button", x: 9.5, y: 9, w: 9.5, h: 1, static: false },
      {
        i: "report-buttons",
        x: 19,
        y: user && user["custom:type"] === "admin" ? 0 : 1,
        w: 5,
        h: user && user["custom:type"] === "admin" ? 9 : 6,
        static: false,
      },
      { i: "actions", x: 19, y: 0, w: 5, h: 1, static: false },
      ...(size === "medium" || size === "large"
        ? []
        : [{ i: "show-hide-button", x: 0, y: 0, w: 19, h: 1, static: false }]),
    ],
    [user, size, rootStore.emsStore.getResponsiveState.showEmergencyDetails, chatCardMediumLayouts]
  );
 const calculateMedicalEmergencyCardHeight = (contentHeight: number) => {
    console.log("contentHeight",contentHeight);
  }

  const layouts = {
    lg: layout_large,
    md: layout_medium,
  };

  const handleSeeAllReport = () => {
    rootStore.emsStore.setSeeAll();
  }
  const handleReportModalClose = () => {
    rootStore.emsStore.setSeeAll();
  }

  // chat card function
  function crewChatExpand() {
    rootStore.emsStore.toggleCrewExpand();
  }
  function crewVideoCallIcon() {
    rootStore.emsStore.toggleCrewVideoCall();
  }
  function crewAudioCallIcon() {
    rootStore.emsStore.toggleCrewAudioCall();
  }
  
  function captainChatExpand() {
    rootStore.emsStore.toggleCaptainExpand();
  }
  function captainVideoCallIcon() {
    rootStore.emsStore.toggleCaptainVideoCall();
  }

  // const notesUpdated = (key: string, event: React.ChangeEvent<HTMLTextAreaElement>) => {
  //   if (rootStore.emsStore.getSelectedEmergency) {
  //       rootStore.emsStore.handleAllNotes(key, event.target.value);
  //    const notes = {
  //             ...rootStore.emsStore.getAllNotes,
  //             Attachment: ""
  //       }
  //     MedicalEmergencyService.updateMedicalEmergencyNotes(rootStore.emsStore.getSelectedEmergency?.id, notes);
  //   }
  // };

  // const notesUpdated = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
  //   if (rootStore.emsStore.getSelectedEmergency) {
  //     const notes = event.target.value;
  //     rootStore.emsStore.handleNotes(notes);
  //     MedicalEmergencyService.updateNotes(notes, rootStore.emsStore.getSelectedEmergency?.id);
  //   }
  // };

  const timeoutIdRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  
  const notesUpdated = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    const notes = event.target.value;
    rootStore.emsStore.handleNotes(notes);

    if (timeoutIdRef.current) {
      clearTimeout(timeoutIdRef.current);
    }

    const emergencyId = rootStore.emsStore.getSelectedEmergency?.id;

    if (emergencyId !== undefined) {
      timeoutIdRef.current = setTimeout(() => {
        MedicalEmergencyService.updateNotes(notes, emergencyId);
        timeoutIdRef.current = null;
      }, 30000);
    }
  };

  useEffect(() => {
  return () => {
    if (timeoutIdRef.current) {
      clearTimeout(timeoutIdRef.current);
      timeoutIdRef.current = null;
      const notes = rootStore.emsStore.getNotes;
      const emergencyId = rootStore.emsStore.getSelectedEmergency?.id;
      if(emergencyId){
        MedicalEmergencyService.updateNotes(notes, emergencyId);
      }
    }
  };
}, []);


  async function FindReportLength() {
   await ReportLength();
  //  await ReportLength(ReportNameEnum.po);
  //  await ReportLength(ReportNameEnum.bpm);
  //  await ReportLength(ReportNameEnum.aed);
  }
  useEffect(() => {
    console.log('Red Dot' + rootStore.emsStore.getReportCount);
    FindReportLength();

    return () => {
      rootStore.emsStore.resetAllReportList();
      rootStore.emsStore.resetFilterReportList();
      rootStore.emsStore.resetSeeAll();
      rootStore.emsStore.resetReportList();
    }
  },[rootStore.emsStore.getReportCount]);

  let userInfo;
  useEffect(() => {
    (
      async () => {
        userInfo = localStorage.getItem("userinfo");
        if (userInfo !== null) {
          let roleLabel = JSON.parse(userInfo).roleLabel;
           // navigate to home if admin try to access
          if (roleLabel.toLowerCase() == "admin") {
            navigation("/home");
          }
          rootStore.adminStore.handleRoleLabel(roleLabel);
        }
      }
    )();
  }, [userInfo]);

  const formateTimestamp = (timestamp: string) => {
    const milliseconds = parseInt(timestamp);
    const dateObject = new Date(milliseconds);
    const year = dateObject.getFullYear();
    const month = (dateObject.getMonth() + 1).toString().padStart(2, '0');
    const day = dateObject.getDate().toString().padStart(2, '0');
    let hours = dateObject.getHours();
    const minutes = dateObject.getMinutes().toString().padStart(2, '0');
    const period = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12;
    const formattedDateTime = `${year}-${month}-${day} ${hours}:${minutes} ${period}`;
    return formattedDateTime;
  }

  const [isSidebarOpen, setIsSidebarOpen] = useState(false);


  const openSidebar = () => {

    setIsSidebarOpen(true);
  };
  const closeSidebar = () => setIsSidebarOpen(false);

  const onScanNotified = () => {
    getNotifykit();
  }
  
  useEffect(() => {
    getMedicalKit();
  }, [rootStore.medicalKitStore.getIsMedicalKit, rootStore.emsStore.getMedicalKitRefresh]);
  
  const getMedicalKit = async () => {
    try {
      if(medicalEmergencyId != undefined){
        const MedicalData = await MedicalEmergencyService.getMedical(medicalEmergencyId);
        rootStore.emsStore.setMedicalKitId(MedicalData.scannedKit);
        rootStore.medicalKitStore.handleIsMedicalKit(MedicalData.scannedKitFlag);
        rootStore.medicalKitStore.setMedicalKitNotifyTime(MedicalData.scannedKitTimeStamp);
      }
    } catch (error) {
      console.error("Error fetching medical kits:", error);
    }
  };

  const getMedicalKitItems = async (flightId: string) => {
    try{
      const medicalKitList = await MedicalEmergencyService.getMedicalKitItems(flightId)
      setMedicalKitItems(medicalKitList);
    } catch (err) {
      console.error("Error fetching medical kits items:", err)
    }
  }

  useEffect(()=>{
    if(rootStore.emsStore.getSelectedEmergency?.flightId){
      getMedicalKitItems(rootStore.emsStore.getSelectedEmergency?.flightId)
    }
  },[rootStore.emsStore.getSelectedEmergency])

 


  const notifyUsers2 = useCallback(
    async (emergencyname: string, msg: string) => {
      if (!user || !rootStore.emsStore.getSelectedEmergency) return;
      const notificationHelper = new NotificationHelper();
      const medicalEmergencyHelper = new MedicalEmergencyHelper();
      let users = [];
      let cognitoUserId = null;
      if (user["custom:type"] === "ems") {
        cognitoUserId = await medicalEmergencyHelper.findCrew(
          rootStore.emsStore.getSelectedEmergency.id
        );
      }
      if (cognitoUserId) {
        users.push(cognitoUserId);
      }
      if (users.length != 0) {
        notificationHelper.sendNotification(emergencyname, msg, users);
      }
    },
    [rootStore.emsStore.getSelectedEmergency, user]
  );

  // Format Time
  const formatTimeStamp = (timeStamp: string | undefined) => {
    if (timeStamp !== undefined) {
      let DatenTime = timeStamp?.split("T");
      if (DatenTime) {
        let time = DatenTime[0];
        let datePart = DatenTime[1];
        let date = datePart.split("Z")[0];
        return time + " " + date;
      }
    }
  };


  const getNotifykit = async () => {
    try {
      if(medicalEmergencyId != undefined){
        const result = await MedicalEmergencyService.getNotified(medicalEmergencyId);
        rootStore.medicalKitStore.handleIsMedicalKit(result.scannedMedicalKitFlag);
        if (rootStore.emsStore.getSelectedEmergency) {
          sendDataToTopic(
            rootStore.emsStore.getSelectedEmergency?.id,
            rootStore.emsStore.getSelectedEmergency?.flightId,
            Autoupdateenum.MedicalKit
          );
          rootStore.successStore.showNotification("Medical Kit", rootStore.emsStore.getSelectedEmergency?.createdBy, "medicalkit", 3000);
        }
      }
    } catch (error) {
      console.error("Error fetching medical kits:", error);
    }
  };
  
  return (
    <>
    <Box style={{height: '100%'}}>
      <Box direction="row" className="medical-detail-strip">
        <div className="left">
          <div className="left-inner">
            <img src={backArrow} alt='back arrow button' onClick={() => navigation(-1)} />
            <div style={{ marginLeft: 12 }}>
  {/* Passenger Name with Label */}
  <div>
    <Text style={{ fontSize: "13px", fontWeight: "bold", color: "#4B628A" }}>Passenger Name:</Text>
    <Text className="pass-name" style={{ fontSize: "13px", fontWeight: "600", marginLeft: "8px" }}>
      {rootStore.emsStore.getPassenger?.name ?? "Not Specified"}
    </Text>
  </div>

  {/* Incident Created and Tel Number on Same Line */}
  <div style={{display: "flex", alignItems: "center" }}>
    <Text style={{ fontSize: "13px", fontWeight: "bold", color: "#4B628A" }}>Incident Created:</Text>
    <Text className="time-and-tailno" style={{ fontSize: "13px", fontWeight: "700", marginLeft: "8px" }}>
      {formatTimeStamp(rootStore.emsStore.getSelectedEmergency?.timestamp)}
    </Text>
    <Text style={{ marginLeft: "24px", fontSize: "13px", fontWeight: "bold", color: "#4B628A" }}>&nbsp;&nbsp;Tail Number:</Text>
    <Text className="time-and-tailno" style={{ fontSize: "13px", fontWeight: "700", marginLeft: "8px" }}>
      {rootStore.emsStore.getSelectedEmergency?.flightPrimaryKey?.split(";")[0]}
    </Text>
  </div>
</div>


          </div>
        </div>
        <div className="right">
        {user && user["custom:type"] === "ems" ? (
            <button
              className="markResolvedButton"
              onClick={() => onMarkResolvedButtonClick(user.username)}
              disabled={rootStore.emsStore.getSelectedEmergency?.status == "RESOLVED"}
              style={{backgroundColor: rootStore.emsStore.getSelectedEmergency?.status == "RESOLVED" ? "#5CD292" : "#3a82fb"}}
            >
              {rootStore.emsStore.getSelectedEmergency?.status == "RESOLVED" ? "RESOLVED" : "Mark Resolved"}
            </button>
          ) : (
            <button
              className="markResolvedButton"
              disabled={true}
              onClick={() => onMarkResolvedButtonClick()}
              style={{opacity: 0.6,cursor: 'not-allowed',backgroundColor: rootStore.emsStore.getSelectedEmergency?.status == "RESOLVED" ? "#5CD292" : "#3a82fb"}}
            >
              {rootStore.emsStore.getSelectedEmergency?.status == "RESOLVED" ? "RESOLVED" : "Mark Resolved"}
            </button>
          )}
        </div>
      </Box>
    <div className="main-outer" >
    <div className="single-emergency-outer" style={{width: rootStore.adminStore.getRoleName.toLowerCase() == "admin" ? "100%" : "calc(100% - 214px)"}}>
    <div className="single-emergency-container">
    {rootStore.emsStore.getResponsiveState.showEmergencyDetails && (
    <MedicalEmergencyCard
    seatNumber={rootStore.emsStore.getSelectedEmergency?.seatNumber ?? "No Information Provided"}
    age={rootStore.emsStore.getPassenger?.age?.toString() ?? "Not Specified"}
    containerStyle={{  }}
    passengerName={rootStore.emsStore.getPassenger?.name ?? "Not Specified"}
    gender={rootStore.emsStore.getPassenger?.gender ?? "Not Specified"}
    emsId={rootStore.emsStore.getSelectedEmergency?.assignedEms ?? "Not Specified"}
    symptoms={rootStore.emsStore.getSelectedEmergency?.symptoms.split(",") ?? []}
    treatmentsGiven={
      rootStore.emsStore.getSelectedEmergency?.treatmentsGiven ?? []
    }
    status={
      rootStore.emsStore.getSelectedEmergency?.status ??
      MedicalEmergencyStatus.NOTIFIED
    }
    passengerStatusQuestions={
      rootStore.emsStore.getSelectedEmergency?.passengerStatusQuestions ?? []
    }
    online={rootStore.emsStore.getOnlineStatus}
    detail={true}
    diversion={rootStore.emsStore.getDiversionStatus}
    landed={rootStore.emsStore.getFlightLandedStatus}
    time={rootStore.emsStore.getSelectedEmergency?.timestamp}
    flightNo={rootStore.emsStore.getSelectedEmergency?.flightId?.split(";")[0]}
    tailNo={rootStore.emsStore.getSelectedEmergency?.flightPrimaryKey?.split(";")[0]}
    actionMenu={actionButtons}
    cardHeight={calculateMedicalEmergencyCardHeight}
    PatientConscious={rootStore.emsStore.getSelectedEmergency?.isPatientConscious ?? false}
    />
    )}
    <div className="notes-container" style={{flex: rootStore.medicalCardStore.getMedicalCardExpand ? 0 : 1,display: rootStore.medicalCardStore.getMedicalCardExpand ? 'none' : 'flex'}}>
      <Box elevation="xsmall" className="notes" background={"#fff"} fill>
      <Box className="editTitleOuter">
          <Text className="noteTitle">Notes</Text>
        </Box>
        <TextArea
          className="textBox"
          value={rootStore.emsStore.getNotes}
          onChange={notesUpdated}
          fill
          plain
          resize={false}
          rows={7}
          disabled={rootStore.emsStore.getSelectedEmergency?.status == "RESOLVED" ? true : false}
        />
      </Box>
    </div>
    </div>
    <div className="chat-box">
    <div ref={crewChat} style={{display: rootStore.emsStore.getChatType == "captain" ? "none" : "flex",zIndex: rootStore.emsStore.getZIndex ? 2 : 0}} className={rootStore.emsStore.getExpand ? "chat-box-crew addClass" : "chat-box-crew"}>
    {rootStore.emsStore.getVideoCallRecord ? (
    <CustomCard
      className="chat-card-container"
      containerStyle={styles.cardContainer}
    >
    <ChatCard
      type={ChatType.CREW}
      roomId={rootStore.emsStore.getVideoCallRecord.roomId.split(",")[0]}
      style={{ width: "100%", height: "100%" }}
      status={rootStore.emsStore.getSelectedEmergency?.status}
      onVideocallBtnClicked={onVideocallBtnClicked}
      onAudiocallBtnClicked={onAudiocallBtnClicked}
      isExpandHover={rootStore.emsStore.getCrewExpandIcon}
      isVideoCallHover={rootStore.emsStore.getCrewVideoIcon}
      isAudioCallHover={rootStore.emsStore.getCrewAudioIcon}
      videoHover={crewVideoCallIcon}
      audioHover={crewAudioCallIcon}
      expandHover={crewChatExpand}
    />
    </CustomCard>
    )
  :
  (
    <Box align="center" justify="center" alignContent="center">
      <div className="loader-03"></div>
    </Box>
  )}
    </div>
    {
    rootStore.adminStore.getRoleName.toLowerCase() == "ems"
    ?
    // <div className="medical-kit-scan-container" style={{boxShadow: rootStore.medicalCardStore.getMedicalCardExpand ? "none" : "0px 0px 20px 4px rgba(216, 225, 244, 0.70)"}}>
    <div className="medical-kit-scan-container">
    {/* {rootStore.medicalKitStore.getIsMedicalKit == null ? */}
    {!medicalKitItems.length ?
    (
      <div style={{display: 'flex',height: '100%',justifyContent: 'space-between'}}>
        {/* <div className="notes-container" style={{display: rootStore.medicalCardStore.getMedicalCardExpand ? 'flex' : 'none',paddingTop: 0,paddingRight: 7,width: '50%',height: '100%'}}> */}
        <div className="notes-container" style={{display: rootStore.medicalCardStore.getMedicalCardExpand ? 'flex' : 'none',paddingTop: 0,paddingRight: 7,width: '100%',height: '100%'}}>
          <Box elevation="xsmall" className="notes" background={"#fff"} fill>
            <Box className="editTitleOuter">
              <Text className="noteTitle">Notes</Text>
            </Box>
              <TextArea
              className="textBox"
              value={rootStore.emsStore.getNotes}
              onChange={notesUpdated}
              fill
              plain
              resize={false}
              rows={7}
              disabled={rootStore.emsStore.getSelectedEmergency?.status == "RESOLVED" ? true : false}
              />
          </Box>
        </div>
        {/* <Box className="medicalKit" style={{width: rootStore.medicalCardStore.getMedicalCardExpand ? 'calc(50% - 7px)': '100%'}}>
          <Box className="titleMain">
            <img src={medicalKit} alt="medical kit icon" style={{ height: 16, width: 16 }} />
            <Text className="medicalKitTitle">Medical Kit</Text>
          </Box>
          <Box className="btnOuter">
            <Box className="scane-content">
              <img src={nodata} alt="no data icon" style={{ height: 16, width: 16 }} />
              <Text className="scan-hr-ago"> No data</Text>
            </Box>
            <Button  disabled={rootStore.emsStore.getSelectedEmergency?.status == "RESOLVED"} className="noeMoreBtn" onClick={onScanNotified}>

              <img src={docScanner} style={{ width: 20, height: 20, marginRight: 4 }} alt="scan icon" />
              Scan medical kit
            </Button>
          </Box>
        </Box> */}
        <Box className="medicalKit" style={{width: rootStore.medicalCardStore.getMedicalCardExpand ? 'calc(50% - 7px)': '100%'}}>
          <Box className="titleMain">
            <img src={medicalKit} alt="medical kit icon" style={{ height: 16, width: 16 }} />
            <Text className="medicalKitTitle">Medical Kit Items</Text>
          </Box>
          <Box className="btnOuter">
            <Box className="scane-content">
              <img src={nodata} alt="no data icon" style={{ height: 16, width: 16 }} />
              <Text className="scan-hr-ago"> No data</Text>
            </Box>
          </Box>
        </Box>
      </div>
    )
    :
    (
      <div style={{display: 'flex',height: '100%',justifyContent: 'space-between'}}>
      {/* <div className="notes-container" style={{display: rootStore.medicalCardStore.getMedicalCardExpand ? 'flex' : 'none',paddingTop: 0,paddingRight: 7,width: '50%',height: '100%'}}> */}
      <div className="notes-container" style={{display: rootStore.medicalCardStore.getMedicalCardExpand ? 'flex' : 'none',paddingTop: 0,paddingRight: 7,width: '100%',height: '100%'}}>
        <Box elevation="xsmall" className="notes" background={"#fff"} fill>
          <Box className="editTitleOuter">
            <Text className="noteTitle">Notes</Text>
          </Box>
            <TextArea
            className="textBox"
            value={rootStore.emsStore.getNotes}
            onChange={notesUpdated}
            fill
            plain
            resize={false}
            rows={7}
            disabled={rootStore.emsStore.getSelectedEmergency?.status == "RESOLVED" ? true : false}
            />
        </Box>
      </div>
    {/* <Box className="medicalKit" style={{ background: "#E6E9F0", width: rootStore.medicalCardStore.getMedicalCardExpand ? 'calc(50% - 7px)': '100%' }}>
      <Box className="titleMains">
        <img src={medicalKit} alt="medical kit icon" style={{ height: 16, width: 16 }} />
        <Text className="medicalKitTitle">Medical Kit</Text>
      </Box>
      <Box className="btnOuter">
        <Box className="scane-content">  
          <Text className="scan-hr-ago">{Utility.timelog(rootStore.medicalKitStore.getMedicalKitNotifyTime)}</Text>
        </Box>
        <Button disabled={rootStore.emsStore.getSelectedEmergency?.status == "RESOLVED"} className="noeMoreBtn" onClick={openSidebar}>
          <img src={Se} style={{ width: 20, height: 20, marginRight: 4 }} alt="info icon" />
          Know more
        </Button>
      </Box>
    </Box> */}
      <Box className="medicalKit" style={{ background: "#E6E9F0", width: rootStore.medicalCardStore.getMedicalCardExpand ? 'calc(50% - 7px)' : '100%', height: '100%' }}>
        <Box className="titleMains">
          <img src={medicalKit} alt="medical kit icon" style={{ height: 16, width: 16 }} />
          <Text className="medicalKitTitle">Medical Kit Items</Text>
        </Box>

        {/* Search Input */}
        <Box style={{ padding: '8px 0' }}>
          <input
            type="text"
            placeholder="Search items..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={{
              width: '95%',
              padding: '6px 10px',
              fontSize: 14,
              border: '1px solid #ccc',
              borderRadius: '10px',
              backgroundColor:'#F2F8FF',
              color:'#656566',
              marginBottom:'15px'


            }}
          />
        </Box>
        <Box className="btnOuter" style={{ height: "100%", overflowY: 'auto' }}>
          <ul style={{ padding: 0, margin: 0, listStyle: 'none', height: "100%", width: "100%" }}>
            {filteredItems.length > 0 ? (
              filteredItems.map((item) => (
                <li
                  key={item.name}
                  style={{
                    height: '30px',
                    lineHeight: '30px',
                    paddingLeft: 0,
                    marginLeft: 0,
                    textAlign: 'left',
                    fontSize: "14px",
                    fontWeight: "500",
                    fontStyle: "normal",
                    fontFamily: "Inter",
                    color: "rgb(102, 120, 153)",
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    borderBottom: "1px solid white"
                  }}
                >
                  {item.name}
                </li>
              ))
            ) : (
              <li style={{ padding: "10px", color: "#666" }}>No items found.</li>
            )}
          </ul>
        </Box>
        {/* <Box className="btnOuter" style={{ height:"100%", overflowY: 'auto'}}>
          <ul style={{ padding: 0, margin: 0, listStyle: 'none',height:"100%",width:"100%" }}>
            {medicalKitItems.map((item) => (
              <li key={item.name} style={{ height: '30px', lineHeight: '30px', paddingLeft: 0, marginLeft: 0, textAlign: 'left',fontSize:"14px",fontWeight:"500",fontStyle:"normal",fontFamily:"Inter",color:"rgb(102, 120, 153)",overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', borderBottom:"1px solid white"
            }}>
                {item.name}
              </li>
            ))}
          </ul>
        </Box> */}
      </Box>
    </div>
    )
    }
    <Sidebar isOpen={isSidebarOpen} closeSidebar={closeSidebar} />
    </div>
    : rootStore.adminStore.getRoleName.toLowerCase() == "superadmin"
    ?
  <div className="medical-kit-scan-container">
    <div style={{display: 'flex',height: '100%',justifyContent: 'space-between'}}>
      <div className="notes-container" style={{display: rootStore.medicalCardStore.getMedicalCardExpand ? 'flex' : 'none',paddingTop: 0,paddingRight: 7,width: '100%',height: '100%'}}>
        <Box elevation="xsmall" className="notes" background={"#fff"} fill>
            <Box className="editTitleOuter">
              <Text className="noteTitle">Notes</Text>
            </Box>
            <TextArea
              className="textBox"
              value={rootStore.emsStore.getNotes}
              onChange={notesUpdated}
              fill
              plain
              resize={false}
              rows={7}
              disabled={rootStore.emsStore.getSelectedEmergency?.status == "RESOLVED" ? true : false}
            />
        </Box>
      </div>
    </div>
  </div>
    :
    null
    }
    {/* <div ref={captainChat} style={{display: rootStore.emsStore.getChatType == "crew" ? "none" : "flex"}} className={rootStore.emsStore.getExpand ? "captain-chat chat-box-captain captainAddClass" : "captain-chat chat-box-captain"} >
    {rootStore.emsStore.getVideoCallRecord && rootStore.emsStore.getVideoCallRecord?.captainRoomId !== null ?
      <CustomCard
      className="chat-card-container"
      containerStyle={styles.cardContainer}
      >
        <ChatCard
        type={ChatType.CAPTAIN}
        roomId={rootStore.emsStore.getVideoCallRecord.captainRoomId.split(",")[0]}
        style={{ width: "100%", height: "100%" }}
        status={rootStore.emsStore.getSelectedEmergency?.status}
        onVideocallBtnClicked={onVideocallBtnClicked}
        isExpandHover={rootStore.emsStore.getCaptainExpandIcon}
        isVideoCallHover={rootStore.emsStore.getCaptainVideoIcon}
        videoHover={captainVideoCallIcon}
        expandHover={captainChatExpand}
        />
      </CustomCard>
    :
    (<></>)
    }
    </div> */}
    </div>
    </div>

    <div className="report-container" style={{display: rootStore.adminStore.getRoleName.toLowerCase() == "admin" ? "none" : "block"}}>
    {rootStore.adminStore.getRoleName.toLowerCase() == "ems" ? (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        position: 'relative',
      }}
    >
    <div className={rootStore.emsStore.getSeeAll ? "all-report-container expand-report" : "all-report-container"}>
        <Box className="reportTitle" style={{justifyContent: rootStore.emsStore.getSeeAll ? "space-between" : "center"}}>
          <Box className="report-cards-title">
            <img src={reportFlowSheet} alt="report flow sheet" style={{height: 16, width: 16}} />
            <Text className="report-main-title">Patient’s Vitals</Text>
          </Box>
          {/* {
            rootStore.emsStore.getSeeAll
                &&
            <button onClick={handleReportModalClose} className="report-modal-close"><img src={closeSmall} /><span>Close</span></button>
          } */}
        </Box>
      {/* <Box className={rootStore.emsStore.getSeeAll ? "report-group flex-row" : "report-group"}> */}
      <Box className="report-group">
        <ReportButton
          alt="Blood Pressure Monitor Icon"
          imageName="bp.svg"
          title="Blood Pressure Monitor"
          onClick={() => onReportButtonClick(ReportNameEnum.bpm, "Blood Pressure Monitor")}
          reportLength={rootStore.emsStore.getReportIndicator.bloodPressure}
          bgColor="#E5EEFD"
          passenger={rootStore.emsStore.getPassenger?.name ?? "Not Specified"}
          mCrew={rootStore.emsStore.selectedEmergency?.createdBy ?? "Crew"}
          reportType={ReportNameEnum.bpm}
          isDisable={rootStore.emsStore.getSelectedEmergency?.status == "RESOLVED"}
        />
        <ReportButton
          alt="Glucometer Icon"
          imageName="glucometer_svg_icon.svg"
          title="Glucometer"
          onClick={() => onReportButtonClick(ReportNameEnum.gm, "Glucometer")}
          reportLength={rootStore.emsStore.getReportIndicator.glucoMeter}
          bgColor="#FCECE0"
          passenger={rootStore.emsStore.getPassenger?.name ?? "Not Specified"}
          mCrew={rootStore.emsStore.selectedEmergency?.createdBy ?? "Crew"}
          reportType={ReportNameEnum.gm}
          isDisable={rootStore.emsStore.getSelectedEmergency?.status == "RESOLVED"}
        />
        <ReportButton
          alt="Pulse Oximeter Icon"
          imageName="PatientPicture.svg"
          title="Pulse Oximeter"
          onClick={() => onReportButtonClick(ReportNameEnum.po,"Pulse Oximeter")}
          reportLength={rootStore.emsStore.getReportIndicator.oxiMeter}
          bgColor="#fef7d1"
          passenger={rootStore.emsStore.getPassenger?.name ?? "Not Specified"}
          mCrew={rootStore.emsStore.selectedEmergency?.createdBy ?? "Crew"}
          reportType={ReportNameEnum.po}
          isDisable={rootStore.emsStore.getSelectedEmergency?.status == "RESOLVED"}
        />
        <ReportButton
          alt="AED Icon"
          imageName="thermometer.png"
          title="Thermometer"
          onClick={() => onReportButtonClick(ReportNameEnum.aed,"Thermometer")}
          reportLength={rootStore.emsStore.getReportIndicator.aed}
          bgColor="#d7fff4"
          passenger={rootStore.emsStore.getPassenger?.name ?? "Not Specified"}
          mCrew={rootStore.emsStore.selectedEmergency?.createdBy ?? "Crew"}
          reportType={ReportNameEnum.aed}
          isDisable={rootStore.emsStore.getSelectedEmergency?.status == "RESOLVED"}
        />
      </Box>
      {
      rootStore.emsStore.getReportList
          &&
        <ReportList />
      }
      <Box className="down-angle">
        <img src={reportDown} alt="report card down icon" />
      </Box>
        {/* <Box className="see-all-outer" style={{display: rootStore.emsStore.getSeeAll ? "none" : "flex"}}>
          <button  onClick={() => handleSeeAllReport()} className="see-all-btn">
            <img src={seeAll} style={{width: 20, height: 20}} />
            <Text className="see-all-txt" >See all</Text>
          </button>
        </Box> */}
    </div>

   <Assistant isDisable={rootStore.emsStore.getSelectedEmergency?.status == "RESOLVED"} />
      {/* {user && user["custom:type"] === "ems" ? (
        <button
          className="markResolvedButton"
          onClick={() => onMarkResolvedButtonClick(user.username)}
          disabled={rootStore.emsStore.getSelectedEmergency?.status == "RESOLVED"}
          style={{backgroundColor: rootStore.emsStore.getSelectedEmergency?.status == "RESOLVED" ? "#5CD292" : "#3a82fb"}}
        >
          Mark Resolved
        </button>
      ) : (
        <button
          className="markResolvedButton"
          disabled={true}
          onClick={() => onMarkResolvedButtonClick()}
          style={{opacity: 0.6,cursor: 'not-allowed'}}
        >
          Mark Resolved
        </button>
      )} */}
    </div>
    ) : rootStore.adminStore.getRoleName.toLowerCase() == "superadmin" ? (
    <CustomCard className="event-container" containerStyle={styles.cardContainer}>
      <Text className="card-title">Events</Text>
      {rootStore.emsStore.getEvents.length != 0 ? (
        <EventTimeline
          events={rootStore.emsStore.getEvents.map((event) => {
            return {
              createdAt: formateTimestamp(event.timestamp),
              description: "",
              title: EventTypeToTextMapper[event.eventType].text,
              icon: EventTypeToTextMapper[event.eventType].icon,
            };
          })}
        />
      ) : (
        <Text
          size="small"
          margin={"10px"}
          color={StandardColors.black_40}
        >
          No Events
        </Text>
      )}
    </CustomCard>
    ) : null }
    </div>
    </div>
      {/* Report Image Viewer */}
      {rootStore.emsStore.getReportImageState.showImage && (
        <ImageViewer
          src={[rootStore.emsStore.getReportImageState.imageUrl]}
          currentIndex={0}
          onClose={closeImage}
          backgroundStyle={{
            zIndex: 10000,
            backgroundColor: "rgba(0,0,0,0.7)",
          }}
        />
      )}

      {/* Chat Image Viewer */}
      {rootStore.emsStore.getChatImageState.showImage && (
        <ImageViewer
          src={[rootStore.emsStore.getChatImageState.imageUrl]}
          currentIndex={0}
          onClose={closeChatImage}
          backgroundStyle={{
            zIndex: 10000,
            backgroundColor: "rgba(0,0,0,0.7)",
            color: '#fff'
          }}
        />
      )}
      
      <ConfirmationDialog
        confimButtonText="Confirm"
        title="Do you want to mark this emergency as Resolved?"
        show={rootStore.emsStore.getDialogState.showConfirmation}
        onCancel={() =>
          rootStore.emsStore.handleDialogState({showConfirmation: false,showLoginPrompt: rootStore.emsStore.getDialogState.showLoginPrompt})
          // setDialogState((prev) => {
          //   return { ...prev, showConfirmation: false };
          // })
        }
        onDone={markResolved}
        typingValidationText={"MARK"}
      />
      {rootStore.emsStore.getDialogState.showLoginPrompt && (
        <LoginPrompt
          onCancel={cancelLoginPrompt}
          onConfirmed={recommendDiversion}
        />
      )}

      {
        rootStore.emsStore.getResolvedPopUp
        ?
        <ResolvedRestrictModal />
        :
        null
      }
    </Box>

    </>
  );
});

const styles: StyleSheet = {
  footerCard: {},
  videoCallButton: {
    backgroundColor: StandardColors.primary_blue_100,
    width: "100px",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    height: "80px",
  },
  cardContainer: { alignItems: "center", height: "100%" },
};


export default MedicalEmergencyDetails